// actions/mail.ts — M1
import { defineAction, type Ok } from '../define';
import { g, MAX_TEXT } from '../guard';
import type { ItemId, MailId, ResidentId } from '../../types/ids';
import type { ItemView } from '../../types/items';
import type { MailFull } from '../../types/mail';
declare module '../registry' {
  interface ActionMap {
    'mail.send': { req: { to: ResidentId; body: string; stationery: ItemId; gift: ItemId | null; wrapping: ItemId | null }; res: { deliverAt: number } };
    'mail.open': { req: { mail: MailId }; res: { mail: MailFull } };
    'mail.take': { req: { mail: MailId }; res: { item: ItemView } };
    'mail.delete': { req: { mail: MailId }; res: Ok };
  }
}
export const mailSend = defineAction('mail.send', g.obj({
  to: g.id<ResidentId>('r'), body: g.str(0, MAX_TEXT), stationery: g.id<ItemId>('i'),
  gift: g.nullable(g.id<ItemId>('i')), wrapping: g.nullable(g.id<ItemId>('i')),
}));
export const mailOpen = defineAction('mail.open', g.obj({ mail: g.id<MailId>('m') }));
export const mailTake = defineAction('mail.take', g.obj({ mail: g.id<MailId>('m') }));
export const mailDelete = defineAction('mail.delete', g.obj({ mail: g.id<MailId>('m') }));
